<template>
  <dropdown-filters @clicked="addFilter" title="Escalas" :items="listSchedules" :icon="scaleIcon" />
</template>

<script lang="ts">
import { defineAsyncComponent, onMounted, watch } from 'vue'
import DropdownFilters from '../components/DropdownFilters.vue'
import { useScheduleStore } from '@/pinia-store/useScheduleStore'
import { storeToRefs } from 'pinia'
import { useStationStore } from '@/pinia-store/useStationStore'

export default {
  components: {
    DropdownFilters
  },
  setup() {
    const stationStore = useStationStore()
    const scheduleStore = useScheduleStore()
    const { listSchedules } = storeToRefs(scheduleStore)
    const { listStationsQuery } = storeToRefs(stationStore)

    const scaleIcon = defineAsyncComponent(() => import('@/assets/icons/scale.vue'))

    const syncSchedules = async (healthUnits: string[] | undefined) => {
      if (healthUnits?.length) {
        await scheduleStore.setSchedulesByHealthUnits(healthUnits.map(Number))
      } else {
        await scheduleStore.getAllSchedules()
      }

      const availableIds = new Set(listSchedules.value.map((s) => s.value))
      const selectedSchedules = listStationsQuery.value.schedules || []
      const invalidSchedules = selectedSchedules.filter((id) => !availableIds.has(id))

      for (const id of invalidSchedules) {
        await stationStore.removeScheduleFilter(id)
      }
    }

    onMounted(() => {
      syncSchedules(listStationsQuery.value.healthUnits)
    })

    watch(() => listStationsQuery.value.healthUnits, syncSchedules, { deep: true })

    const addFilter = async (val: { title: string; value: string }) => {
      await stationStore.setScheduleFilter(+val.value, 'add')
    }

    return {
      scaleIcon,
      addFilter,
      listSchedules
    }
  }
}
</script>

<style></style>
